import { IAnnotationData } from "../shared/types";
import { AnnotationActions } from "./constants";

const StoreKey = (): string => `annotation-data-${window.ambrosia?.$id}`;

const getAnnotationsFromStorage = () => {
  return new Map(JSON.parse(window.localStorage.getItem(StoreKey()) as string));
};

const getAnnotations = (pageId?: string) => {
  const annotationDataMap = getAnnotationsFromStorage();
  if (pageId) {
    return (annotationDataMap.get(pageId) as Array<IAnnotationData>) || [];
  } else {
    return annotationDataMap;
  }
};

const saveAnnotation = (data: IAnnotationData) => {
  const annotationDataMap = getAnnotationsFromStorage();
  const annotationData = (annotationDataMap.get(data.pageId) as Array<IAnnotationData>) || [];

  const annotationIndex = annotationData.findIndex(
    (annotation: IAnnotationData) => annotation.annotationId == data.annotationId,
  );

  if (annotationIndex !== -1) {
    if (data.actionType === AnnotationActions.Delete) {
      annotationData.splice(annotationIndex, 1);
    } else {
      annotationData[annotationIndex] = data;
    }
  } else {
    annotationData.push(data);
  }

  annotationDataMap.set(data.pageId, annotationData);

  window.localStorage.setItem(StoreKey(), JSON.stringify([...annotationDataMap]));
};

export const DataProvider = {
  getAnnotations,
  saveAnnotation,
};
